import {
  transformQualification,
  transformQualificationForServer,
} from '@data/qualification'
import {
  tranformFlotoScheduleForServer,
  transformFlotoSchedule,
} from '@data/report'
import { getEncryptedPassword, getDecryptedPassword } from '@utils/password'

export function transformWarrantySync(warrantySync) {
  return {
    id: warrantySync.id,
    name: warrantySync.name,
    description: warrantySync.description,
    enabled: !warrantySync.disabled,
    proxyConfigId: warrantySync.proxyConfigId,
    qualifications: transformQualification(
      warrantySync.qualification || { groups: [], operators: [] }
    ),
    apiVendor: warrantySync.apiVendor,
    clientId: warrantySync.clientId
      ? getDecryptedPassword(warrantySync.clientId)
      : undefined,
    clientSecret: warrantySync.clientSecret
      ? getDecryptedPassword(warrantySync.clientSecret)
      : undefined,
    syncFor: warrantySync.syncFor,
    schedularEnabled: !warrantySync.schedularDisabled,
    notifyEmails: warrantySync.notifyEmails,
    notifyGroupIds: warrantySync.notifyGroupIds,
    notifyUserIds: warrantySync.notifyUserIds,
    syncSchedule: {
      ...(warrantySync.syncSchedule
        ? transformFlotoSchedule({
            flotoSchedule: warrantySync.syncSchedule || {},
          })
        : {}),
    },
  }
}

export function transformWarrantySyncForServer(warrantySync) {
  return {
    id: warrantySync.id,
    name: warrantySync.name,
    description: warrantySync.description,
    proxyConfigId: warrantySync.proxyConfigId,
    qualification: transformQualificationForServer(warrantySync.qualifications),
    apiVendor: warrantySync.apiVendor,
    clientId: warrantySync.clientId
      ? getEncryptedPassword(warrantySync.clientId)
      : undefined,
    clientSecret: warrantySync.clientSecret
      ? getEncryptedPassword(warrantySync.clientSecret)
      : undefined,
    syncFor: warrantySync.syncFor,
    schedularDisabled: !warrantySync.schedularEnabled,
    notifyEmails: warrantySync.notifyEmails,
    notifyGroupIds: warrantySync.notifyGroupIds,
    notifyUserIds: warrantySync.notifyUserIds,
    ...(warrantySync.syncSchedule &&
    Object.keys(warrantySync.syncSchedule).length > 0
      ? {
          syncSchedule: tranformFlotoScheduleForServer(
            warrantySync.syncSchedule
          ),
        }
      : {}),
    disabled: !warrantySync.enabled,
  }
}

export function transformWarrantySyncHistory(warrantySyncHistory) {
  return {
    id: warrantySyncHistory.id,
    syncDate: warrantySyncHistory.syncDate,
    devicesProcessed: warrantySyncHistory.devicesProcessed,
    devicesFailed: warrantySyncHistory.devicesFailed,
    devicesSkipped: warrantySyncHistory.devicesSkipped,
    devicesUpdated: warrantySyncHistory.devicesUpdated,
    status: warrantySyncHistory.status,
  }
}

export function transformWarrantySyncFailedDevices(warrantySyncFailedDevices) {
  return {
    id: warrantySyncFailedDevices.id,
    deviceName: warrantySyncFailedDevices.deviceName,
    errorMessage: warrantySyncFailedDevices.errorMessage,
  }
}
